import {getBuildsApiUrl} from './api';

/**
 * The static-builds-worker exposes exactly these three slugs. No auth, no version numbers on the
 * frontend side — it always resolves to whatever build is currently marked stable, and streams the
 * installer directly (`Content-Disposition: attachment`), so a plain `<a href>` is all a caller
 * needs. A platform with nothing published yet 404s with a JSON body; the response is edge-cached
 * for an hour, so a just-published release can take a little while to show up.
 */
export type MapperPlatform = 'windows' | 'mac-arm64' | 'mac-x64';

export const MAPPER_PLATFORMS: {platform: MapperPlatform; label: string}[] = [
  {platform: 'windows', label: 'Windows'},
  {platform: 'mac-arm64', label: 'Mac (Apple Silicon)'},
  {platform: 'mac-x64', label: 'Mac (Intel)'},
];

/** Direct download URL for one platform's installer. */
export function getMapperDownloadUrl(platform: MapperPlatform): string {
  return `${getBuildsApiUrl()}/${platform}`;
}

/**
 * Best-effort guess at the visitor's platform, used only to highlight one download as
 * recommended — it never hides or disables the other two. Apple gives browsers no reliable way to
 * tell Apple Silicon from Intel (Rosetta makes Safari/Chrome report "Intel Mac OS X" either way),
 * so on a Mac this just assumes Apple Silicon, which is the safer default given what Apple
 * currently sells.
 */
export function detectRecommendedPlatform(): MapperPlatform | null {
  if (typeof navigator === 'undefined') return null;
  const ua = navigator.userAgent;

  if (/Windows/i.test(ua)) return 'windows';
  if (/Mac OS X|Macintosh/i.test(ua)) return 'mac-arm64';
  return null;
}
